import React from "react";
import { IoMdClose } from "react-icons/io";

export default function Modal({enable, title, label,content, handleSave, handleCancel, handleAddClick}) {
  return (
    <>
      <div className={`${enable ? "block": "hidden"} overflow-y-auto overflow-x-hidden fixed top-0 right-0  z-50 inset-0 bg-gray-500 bg-opacity-75 transition-opacity justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] bg-[#0000002e]`}>
        <div className="card-center relative p-4 w-full max-w-2xl max-h-full">
          {/* <!-- Modal content --> */}
          <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
            {/* <!-- Modal header --> */}
            <div className="flex items-center justify-between p-4 md:p-5 rounded-t dark:border-gray-600">
            <h3 className=" text-xl font-semibold">
            {title}
            </h3>
              {/* <button
                onClick={()=> handleSave()}
                type="button"
                className="text-white bg-[#58A889] hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-md text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              >
                Save
              </button> */}
              <button
                type="button"
                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                onClick={() => handleCancel()}
              >
                <IoMdClose
                className="w-3 h-3"
                
                />
                <span className="sr-only">Close modal</span>
              </button>
            </div>
            {/* <!-- Modal body --> */}
              {label}
            <div className="p-4 md:p-5 space-y-4">
              {content}
            </div>
            {/* <!-- Modal footer --> */}
            <div className="flex justify-end items-center p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
              <button
                onClick={(e)=> handleSave(e)}
                type="button"
                className="mr-3 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-md text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              >
                Save
              </button>
              <button
                onClick={() => handleCancel()}
                type="button"
                className=" text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
